<template>
  <Overlay
    id="login"
    :class="{ hide: hideLogin, 'transition-out': transitionOutLogin }"
  >
    <LoginOverlayHeader />
    <LoginOverlayContent @login="login" />
    <LoginOverlayFooter />
  </Overlay>
</template>

<script>
import Overlay from "@/components/shared/Overlay";
import LoginOverlayHeader from "./LoginOverlayHeader";
import LoginOverlayFooter from "./LoginOverlayFooter";
import LoginOverlayContent from "./LoginOverlayContent";
import LoginVariableFont from "./LoginVariableFont";
import gameStateStore from "@/stores/GameStateStore";

export default {
  name: "LoginOverlay",
  components: {
    Overlay,
    LoginOverlayHeader,
    LoginOverlayContent,
    LoginOverlayFooter,
  },
  data() {
    return {
      transitionOutLogin: gameStateStore.username !== "",
      hideLogin: gameStateStore.username !== "",
    };
  },
  methods: {
    login(username) {
      gameStateStore.username = username;
      this.transitionOutLogin = true;
      setTimeout(() => {
        this.hideLogin = true;
      }, 500);
    },
  },
};
</script>

<style scoped lang="scss">
#login {
  z-index: 99999999999;

  background-color: whitesmoke;
  color: purple;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  &.transition-out {
    transition-property: transform, opacity;
    transition-duration: 450ms;
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);

    transform: translateY(100%);

    opacity: 0;
  }

  &.hide {
    display: none;
  }
}
</style>
